// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyDeliveryMethodWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod,
  RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, UserPropertyDeliveryMethodResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface DeliveryMethodParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Options = UseQueryOptions<
  UserPropertyDeliveryMethodResponseWebDto,
  unknown,
  UserPropertyDeliveryMethodResponseWebDto,
  readonly [string, DeliveryMethodParams]
>;

const RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_GetKey = (getParams: DeliveryMethodParams) =>
  [RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Path, getParams] as const;

export const RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_queryOptions = (
  getParams: DeliveryMethodParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get delivery method of a property
 */
export const useRentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod = (
  getParams: DeliveryMethodParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod.getKey =
  RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_GetKey;
